import { useParams, Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap"; // 引入Modal
import { fetchJson } from "../utils/fetchJson";

export default function NewsDetailPage() {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const [allNews, setAllNews] = useState([]);
  const [prevItem, setPrevItem] = useState(null);
  const [nextItem, setNextItem] = useState(null);

  const [showModal, setShowModal] = useState(false); // 控制模态框的显示
  const [selectedImage, setSelectedImage] = useState(null); // 存储点击的图片

  const navigate = useNavigate();
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const formatYMDToEnglish = (dateStr, type = "us") => {
    const ymdRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!ymdRegex.test(dateStr)) {
      console.warn(`Invalid date format: ${dateStr}, expected YYYY-MM-DD`);
      return dateStr;
    }

    const [year, month, day] = dateStr.split("-").map(Number);
    const monthName = monthNames[month - 1];
    const dayNum = day.toString().replace(/^0/, "");

    if (type === "uk") {
      return `${dayNum} ${monthName} ${year}`;
    } else {
      return `${monthName} ${dayNum}, ${year}`;
    }
  };

  useEffect(() => {
    fetchJson("/json/carousel.json")
      .then((res) => res.json())
      .then((data) => {
        setAllNews(data);

        const index = data.findIndex((d) => String(d.id) === String(id));
        const found = data[index];
        setItem(found);

        setPrevItem(data[index + 1] || null);
        setNextItem(data[index - 1] || null);
      });
  }, [id]);

  if (!item) return <p className="text-center mt-5">Loading...</p>;

  // 找出所有 description_x (按顺序)
  const sections = Object.keys(item)
    .filter((key) => key.startsWith("description_"))
    .sort((a, b) => Number(a.split("_")[1]) - Number(b.split("_")[1]))
    .map((descKey) => {
      const index = descKey.split("_")[1]; // 数字部分
      const imageKey = `image_${index}`;

      return {
        id: index,
        text: item[descKey],
        image: item[imageKey] || null,
      };
    });

  // 渲染底部图片
  const bottomImages = [
    item.image_bottom_1,
    item.image_bottom_2,
    item.image_bottom_3,
  ].filter((image) => image); // 过滤掉值为 null 或 undefined 的图片

  // 点击图片时，打开模态框
  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShowModal(true);
  };

  // 关闭模态框
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedImage(null); // 使用null，而不是空字符串
  };

  return (
    <div>
      {/* 面包屑 */}
      <nav aria-label="breadcrumb" className="mb-2">
        <ol className="breadcrumb m-0 p-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/news">News</Link>
          </li>
          <li className="breadcrumb-item active">{item.title}</li>
        </ol>
      </nav>

      {/* 标题 */}
      <h1>{item.title}</h1>
      <p style={{ color: "gray" }}>{formatYMDToEnglish(item.time)}</p>

      {/* 主图 */}
      {item.image && item.image !== "" && (  // 检查图片路径是否为空
        <img
          src={item.image}
          alt={item.title}
          className="img-fluid rounded mb-4 shadow"
          style={{ maxHeight: "300px" }}
        />
      )}

      {/* description_x 与 image_x 成对渲染 */}
      {sections.map((sec) => (
        <div key={sec.id}>
          <p
            className="text-secondary mb-3"
            style={{ lineHeight: "1.7", whiteSpace: "pre-line", textAlign: "justify" }}
          >
            {sec.text}
          </p>

          {sec.image && sec.image !== "" && (  // 检查图片路径是否为空
            <img
              src={sec.image}
              alt="img"
              className="img-fluid rounded shadow mb-3"
              style={{ maxHeight: "300px", cursor: "pointer" }}
              onClick={() => handleImageClick(sec.image)} // 点击时打开模态框
            />
          )}
        </div>
      ))}

      {/* 渲染底部图片 */}
      {bottomImages.length > 0 && (
        <div>
          {bottomImages.map((image, index) => (
            image && image !== "" && (  // 确保图片路径不是空字符串
              <div key={index}>
                <img
                  src={image}
                  alt={`Bottom Image ${index + 1}`}
                  className="img-fluid rounded shadow mb-3"
                  style={{ maxHeight: "300px", cursor: "pointer" }}
                  onClick={() => handleImageClick(image)} // 点击时打开模态框
                />
              </div>
            )
          ))}
        </div>
      )}

      {/* ---上一篇 下一篇 --- */}
      <div className="d-flex justify-content-between align-items-center mb-2">
        <a
          className="btn btn-outline-primary"
          onClick={() => {
            navigate(`/news`);
            window.scrollTo(0, 0);
          }}
        >
          Back to News
        </a>
        <div className="d-flex gap-3">
          {prevItem ? (
            <a
              className="btn btn-outline-primary"
              onClick={() => {
                navigate(`/news/${prevItem.id}`);
                window.scrollTo(0, 0);
              }}
            >
              Previous
            </a>
          ) : (
            <a className="btn btn-outline-secondary disabled">Previous</a>
          )}

          {nextItem ? (
            <a
              className="btn btn-outline-primary"
              onClick={() => {
                navigate(`/news/${nextItem.id}`);
                window.scrollTo(0, 0);
              }}
            >
              Next
            </a>
          ) : (
            <a className="btn btn-outline-secondary disabled">Next</a>
          )}
        </div>
      </div>

      {/* 图片模态框 */}
      <Modal show={showModal} onHide={handleCloseModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Image Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* 只有在selectedImage不为null时才渲染图片 */}
          {selectedImage && (
            <img
              src={selectedImage}
              alt="Selected"
              className="img-fluid"
              style={{ maxHeight: "80vh", objectFit: "contain" }}
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}
